<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          routeBack="FarmerIndex"
          class="truncate"
          :title="$t('Farmer') + ' - ' + getValue('tostring')"/>
        <show-actions
          :auditButtonShown="true"
          :farmerHasACurrentAudit="farmerHasACurrentAudit"
          :farmerHasAInProgressAudit="farmerHasAInProgressAudit"
          :canCreateAudit="canCreateAudit"
          :deleteItem=allowDelete
          :editItem=allowEdit
          @clickOnConsultAuditBtn="clickOnConsultAuditBtn"
          @clickOnCreateAuditBtn="clickOnCreateAuditBtn"
          @clickOnDeleteBtn="clickOnDeleteBtn"
          @clickOnEditBtn="clickOnEditBtn">
        </show-actions>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.num.Cheptel')}}</div>
                  <div> {{ getValue('cheptelNumber') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.name.elevage')}}</div>
                  <div> {{ getValue('farmName') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Lastname') }}</div>
                  <div> {{ getValue('user.lastName') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Firstname') }}</div>
                  <div> {{ getValue('user.firstName') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.PhoneNumber') }}</div>
                  <div> {{ getValue('user.phoneNumber') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Username') }}</div>
                  <div> {{ getValue('user.username') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.address') }}</div>
                  <div> {{ getValue('address') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.address.details') }}</div>
                  <div> {{ getValue('addressDetails') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.postalCode')}}</div>
                  <div> {{ getValue('postalCode') }}</div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('farmer.city') }}</div>
                  <div> {{ getValue('city') }}</div>
                </div>
              </div>
            </div>

            <div class="row mt-2 ">
              <div class="col-md-12">
                <div class="d-flex flex-column mb-4 custom-border">
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Structure')}}</div>
                  <div class="textual-link" v-if="this.allowDelete" @click="goToStructure(farmer.structure.id )">{{ getValue('structure.tostring') }}</div>
                  <div v-else> {{ getValue('structure.tostring') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Technician')}}</div>
                  <div class="textual-link" v-if="this.allowDelete" @click="goToTechnician(farmer.technician.id )">{{ getValue('technician.tostring') }}</div>
                  <div v-else> {{ getValue('technician.tostring') }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('Audit.state')}}</div>
                  <div v-if="farmer.hasOngoingAudit && farmer.ongoingAudit !== null">
                    <div v-if="farmer.ongoingAudit.realisationDate > new Date().getTime() - 370 * 24 * 60 * 60 * 1000" class="main-color d-flex align-items-center">
                      <i class="ph-custom ph-check-square-fill mr-1"/> {{$t('Complete') + ' (' }}{{new Date(farmer.ongoingAudit.realisationDate) | moment("DD/MM/YY")}}{{')'}}

                    </div>
                    <div class="secondary-color d-flex align-items-center" v-else>
                      <i class="ph-custom ph-check-square-fill mr-1"/> {{$t('Complete') + ' (' }}{{new Date(farmer.ongoingAudit.realisationDate) | moment("DD/MM/YY")}}{{')'}}
                    </div>
                  </div>

                  <div class="secondary-color d-flex align-items-center" v-else-if="farmer.hasInProgressAudit">
                    <i class="ph-custom ph-folder-notch-plus-fill mr-1"/> {{$t('Waiting.validation')}}
                  </div>

                  <div v-else-if="!farmer.hasInProgressAudit && !farmer.hasOngoingAudit">
                    <div class="main-color d-flex align-items-center" v-if="!farmer.technician.isDefaultTechnician">
                      <i class="ph-custom ph-folder-notch-plus-fill mr-1"/> {{$t('Waiting.creation')}}
                    </div>
                    <div class="main-red-color d-flex align-items-center" v-else>
                      <i class="ph-custom ph-x-square-fill mr-1"/> {{$t('No.audit.no.technician')}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ this.farmer.auditsArchived.length > 1 ? $t('Archived.audits') : $t('Archived.audit')}}</div>

                  <div v-if="this.farmer.auditsArchived.length === 0">-</div>

                  <div v-else-if="this.farmer.auditsArchived.length <= 3" class="d-flex flex-column">
                    <div class="textual-link" v-for="(audit, index) in this.farmer.auditsArchived" @click="clickOnShowAuditBtn(audit.serverId)" :key="index">
                      {{new Date(audit.realisationDate) | moment("DD/MM/YY")}}
                    </div>
                  </div>

                  <div v-else-if="!showAllAuditsArchived" class="d-flex flex-column">
                    <div class="textual-link" v-for="(audit, index) in this.farmer.auditsArchived" :key="index"  v-if="index < 3" @click="clickOnShowAuditBtn(audit.serverId)">
                      {{new Date(audit.realisationDate) | moment("DD/MM/YY")}}
                    </div>
                    <div class="textual-link" @click="showAllAuditsArchived = true; divideAuditsIntoColumns()">
                      {{$t('display.x.more.audit', {length: this.farmer.auditsArchived.length-3})}}
                    </div>
                  </div>

                  <div v-else-if="showAllAuditsArchived" class="d-flex flex-column">
                    <div class="row">
                      <div class="col-sm-3" v-for="(auditsArchivedColumn, index) in this.auditsArchivedColumns" :key="index">
                        <div class="textual-link" v-for="(audit, index) in auditsArchivedColumn" @click="clickOnShowAuditBtn(audit.serverId)" :key="index">
                          {{new Date(audit.realisationDate) | moment("DD/MM/YY")}}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      :beginsWithVoyel="true"
      :isFeminine="false"
      :selectedItem="farmer"
      controllerName="farmer"
      itemSingularName="farmer"
      itemSingularNameUpp="Farmer"
      @didDeleteItem="didDeleteItem()">
    </Item-delete-modal>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import ShowActions from '../../components/b122/ShowActions'
import ItemDeleteModal from '../../components/b122/ItemDeleteModal'

export default {

  name: 'FarmerShow',

  components: {
    ShowActions,
    BackArrow,
    DateField,
    PasswordCreationField,
    ItemDeleteModal

  },

  data () {
    return {
      farmerId: this.$route.params.farmerId,
      farmer: {},
      allowDelete: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin,
      allowEdit: this.$store.getters.isAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isStructure || this.$store.getters.isTechnician,
      canCreateAudit: this.$store.getters.isTechnician,
      farmerHasACurrentAudit: false,
      farmerHasAInProgressAudit: false,
      showAllAuditsArchived: false,
      auditsArchivedColumns: []
    }
  },

  computed: {
    getValue () {
      return (path) => {
        const properties = path.split('.')
        let value = properties.reduce((prev, curr) => {
          return prev && prev[curr] ? prev[curr] : null
        }, this.farmer)
        return (value !== null && value !== 'null') ? value : 'N/A'
      }
    }
  },

  mounted () {
    this.fetchData()
  },

  methods: {

    async fetchData () {
      if (this.farmerId) {
        await this.fetchFarmer()
      }
    },

    async fetchFarmer () {
      api
        .get('/farmer/' + this.farmerId)
        .then(response => {
          this.farmer = response.data
          this.farmerHasACurrentAudit = this.farmer.hasOngoingAudit
          this.farmerHasAInProgressAudit = this.farmer.hasInProgressAudit
        })
    },

    clickOnEditBtn () {
      this.$router.push({
        name: 'FarmerEdit',
        params: {
          farmerId: this.farmer.id
        }
      })
    },

    clickOnDeleteBtn () {
      this.$bvModal.show('item-delete-modal')
    },

    clickOnCreateAuditBtn () {
      this.$router.push({
        name: 'AuditCreate',
        params: {
          farmerId: this.farmer.id
        }
      })
    },

    clickOnConsultAuditBtn () {
      this.$router.push({
        name: 'AuditShow',
        params: {
          auditId: this.farmer.ongoingAudit.id
        }
      })
    },

    clickOnShowAuditBtn (auditId) {
      this.$router.push({
        name: 'AuditShow',
        params: {
          auditId: auditId
        }
      })
    },

    didDeleteItem () {
      this.$router.push({
        name: 'FarmerIndex'
      })
    },

    successToast (message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    goToTechnician (id) {
      this.$router.push({
        name: 'TechnicianShow',
        params: {
          techId: id
        }
      })
    },

    goToStructure (id) {
      this.$router.push({
        name: 'StructureShow',
        params: {
          structureId: id
        }
      })
    },

    divideAuditsIntoColumns () {
      let auditsPerColumn = 5
      let remainingAudits = [...this.farmer.auditsArchived]

      if (remainingAudits.length >= 15) {
        auditsPerColumn = Math.ceil(remainingAudits.length / 3)
      }

      while (remainingAudits.length > 0) {
        this.auditsArchivedColumns.push(remainingAudits.splice(0, auditsPerColumn))
      }
      console.log(this.auditsArchivedColumns)
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/farmer/FarmerShow.vue